import {Component, EventEmitter, forwardRef, Input, Output} from '@angular/core';
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {ValueAccessorBase} from "../../commons/value-acessor-base";
import {cpfPattern, cpfPlaceholder} from "../../commons/constants";

const CPF_PROVIDER = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => CpfComponent),
  multi: true,
};

@Component({
  selector: 'cpf',
  template: `<input
  cpfMask
  type="text"
  class="form-control"
  maxlength="14"
  [id]="id"
  [placeholder]="placeholder"
  [disabled]="disabled"
  [(ngModel)]="value"
  (ngModelChange)="notifyChanges($event)"
  (blur)="blurEvt($event)">
`,
  styles: [``],
  providers: [CPF_PROVIDER],
})
export class CpfComponent extends ValueAccessorBase<string> {
  public pattern: string = cpfPattern;

  @Input() placeholder: string = cpfPlaceholder;
  @Input() id: string;

  @Output() blur: EventEmitter<any> = new EventEmitter();

  transform(value: string): string {
    return value ? value.replace(/[^\d]/g, '').trim().slice(0, 11) : value;
  }

  public blurEvt(event): void {
    this.blur.emit(event);
  }
}
